import React, { useState } from "react";
import AccessTo from "../../../../../components/is-show/AccessTo";
import { PA } from "../../../../router/AddRoutesJson";
import {
  deleteUser,
  serverVersionApprRej,
} from "../../../../../api/apiCallManager";
import { useProjectInfoStore } from "../../../../../zustand/store/projectInfoStore";
import useSelectedServerVersionStore from "../../../../../components/hooks/useSelectedServerVersionStore";
import { useMutation } from "@tanstack/react-query";
import { showSuccess } from "../../../../../helpers/alerts";
import { Popconfirm } from "antd";

function ServerVersionApproveRej({ data }) {
  const { setProjectInfoZustandState, projectInfoZustandState } =
    useProjectInfoStore();
  const [isDisabled, setIsDisabled] = useState(false);

  const {
    selectedServerVersionZustandState,
    setSelectedServerVersionZustandState,
  } = useSelectedServerVersionStore();
  const mutation = useMutation({
    mutationFn: serverVersionApprRej,
    onSuccess: (data) => {
      if (data.statusCode == 200) {
        showSuccess("Success");
        setIsDisabled(true);
      }
    },
  });
  const handleButton = (status) => {
    const payload = {
      status: status,
      projectKey: projectInfoZustandState?.project_key,
      server_version: selectedServerVersionZustandState,
    };
    mutation.mutate(payload);
  };
  return (
    <div>
      {data[0]?.projectStatus ? (
        ""
      ) : (
        <>
          {data[0]?.final_eda?.status == "SUCCESS" && (
            <div className="flex space-x-3 my-3 justify-end">
              <Popconfirm
                title="Are you sure to approve?"
                onConfirm={() => handleButton("approved")}
                okText="Yes"
                cancelText="No"
                disabled={isDisabled}
              >
                <button
                  type="primary"
                  className="bg-green-500 hover:bg-green-600 text-white py-1 w-[100px] rounded"
                  disabled={isDisabled}
                >
                  Approve
                </button>
              </Popconfirm>
              <Popconfirm
                title="Are you sure to reject?"
                onConfirm={() => handleButton("rejected")}
                okText="Yes"
                cancelText="No"
                disabled={isDisabled}
              >
                <button
                  type="primary"
                  danger
                  className="bg-red-500  hover:bg-red-600 text-white py-1 w-[100px] rounded"
                  disabled={isDisabled}
                >
                  Reject
                </button>
              </Popconfirm>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default ServerVersionApproveRej;
